module.exports = __webpack_public_path__ + "static/media/diamonds_K.293b2aa1.png";